export const DEFAULT_PREMIUM_BANNER =
  "assets/images/default-premium-banner.png";
export const LOGO = "assets/images/logo.png";
export const PLACEHOLDER = "assets/images/placeholder.jpeg";
export const PREMIUM_TAG = "assets/images/premium_tag.png";
export const SCHOLAR_BG = "assets/images/scholar-bg.png";
export const SCHOLAR_BACK = "assets/images/scholar-back.svg";
export const SCHOLAR_PLAY = "assets/images/scholar-play.svg";
export const SCHOLAR_ICON = "assets/images/scholar-icon.png";
export const SCHOLAR_ARROW = "assets/images/s-arrow.png";
export const SCHOLAR_VIDEO = "assets/images/video-scholar.png";
export const SCHOLAR_PUZZLE = "assets/images/puzzle-scholar.png";
export const SCHOLAR_BOLT = "assets/images/bolt-scholar.png";
export const SCHOLAR_CONVER = "assets/images/convo-scholar.png";
export const SCHOLAR_MERCH = "assets/images/merch-scholar.png";
export const LIVE_CLASS = "assets/images/liveclass.svg";
export const TEST_SCHOLAR = "assets/images/test-scholar.svg";
export const MINUTES = "assets/images/minutes.svg";
export const DPP = "assets/images/dpp.svg";
export const DIVIDER = "assets/images/divider.svg";
export const TITLE_LEFT = "assets/images/title-left.svg";
export const TITLE_RIGHT = "assets/images/title-right.svg";
export const MAP_ICON = "assets/images/map.png";
export const CUSTOMER = "assets/images/customer.svg";
export const BLUE_SCRATCH = "assets/images/blue_scratch.svg";
export const SCRATCH = "assets/images/scratch.svg";
export const FLOW_ARROW = "assets/images/flow_arrow";
export const FLOW_ARROW_BLUE = "assets/images/flow_arrow_blue.png";
export const REFER_AND_EARN_1 = "assets/images/refernearn1.png";
export const REFER_AND_EARN_2 = "assets/images/refernearn2.png";
export const REFER_AND_EARN_3 = "assets/images/refernearn3.png";
export const REFER_TICKET = "assets/images/referTicket.png";
export const SAARTHI_VIDEO_THUMBNAIL =
  "assets/images/saarthiVideoThumbnail.png";
export const WHATSAPP_GREEN = "assets/images/whatsapp_green.svg";
export const GMAIL_ICON = "assets/images/gmail_icon.svg";
export const SELECT_SUBJECT = "assets/images/select_subject.svg";
export const LISTENING_AUDIO_BOOKS = "assets/images/listening_audio_books.svg";
export const VIDEO_PLAY_RED = "assets/images/video_play_red.svg";
export const BLOB_PURPLE = "assets/images/blob_purple.svg";
export const ROTATING_ARROW = "assets/images/rotatingArrow.svg";
export const SAARTHI_HELP_BG = "assets/images/saarthi_help_bg.svg";
export const VIDEO_PLAY_WHITE = "assets/images/white_play.svg";
export const BOTTOM_CARD_CURVE = "assets/images/bottom_card_curve.svg";
export const TESTIMONIAL_BG = "assets/images/testimonial_bg.svg";
export const EXCLAMATION_ICON = "assets/images/exclamation_icon.svg";
export const CROWN_PRIMARY = "assets/images/crown_primary.svg";
export const SURROUNDED_SOUND_ICON = "assets/images/surroundedSoundIcon.svg";
export const SAARTHI_VIDEO_CAM_ON = "assets/images/saarthiVideoCamOn.svg";
export const SAARTHI_CHECK_CIRCLE = "assets/images/saarthiCheckCircle.svg";
export const CONTACT_SUPPORT_ICON = "assets/images/contactSupportIcon.svg";
export const BG_CIRCLE_INDIGO = "assets/images/bg_circle_indigo.svg";
export const CALENDER_ICON = "assets/images/calender_icon.svg";
export const DISCUSS_ICON = "assets/images/discuss_icon.svg";
export const MEETING_ICON = "assets/images/meeting_icon.svg";
export const PLANNING_ICON = "assets/images/planning_icon.svg";
export const TEACHER_ICON = "assets/images/teacher_icon.svg";
export const TESTING_ICON = "assets/images/testing_icon.svg";
export const LIVE_ICON = "assets/images/live_icon.svg";
export const RECOMMENDED_TAG = "assets/images/recommended_tag.svg";
export const POPULAR_TAG = "assets/images/popular_tag.svg";
export const CHECK_YELLOW = "assets/images/check_yellow.svg";
export const CHECK_GREEN = "assets/images/check_green.svg";
export const CROSS_RED = "assets/images/cross_red.svg";
export const CROSS_RED_FADE = "assets/images/cross_red_fade.svg";
export const CHECK_GREEN_FADE = "assets/images/check_green_fade.svg";
export const POLYGON_BLACK = "assets/images/polygon_black.svg";
export const NO_PLANS = "assets/images/no_plans.svg";
export const PLAY_ICON = "assets/images/play_icon.svg";
export const SCROLL_RIGHT_VIOLET = "assets/images/scroll_right_violet.svg";
export const LOCK_ICON = "assets/images/offerings_lock_icon.svg";
export const GRAY_TICK_DARK = "assets/images/tick_gray_dark.svg";
export const CALENDER_WITH_CLOCK = "assets/images/calender_with_clock.svg";
export const BEST_TAG = "assets/images/best_tag.svg";
export const WHATSAPP_APP = "assets/images/whatsapp_icon_new.svg";
export const EXPIRY_CLOCK = "assets/images/expiryClock.svg";
export const RENEW_CAL = "assets/images/renew_cal.svg";
export const SCHOLAR_VERIFIED = "assets/images/scholarVerified.svg";
export const NO_LOCATION = "assets/images/no_location.svg";
